<template>
  <span class="inline-block border border-gray text-14 text-black py-8 px-12 normal-case">
      <slot></slot>
      <button class="w-12 h-12 focus:outline-none text-center text-dark-gray ml-16" v-on="triggers">
        <i class="fal fa-times"></i>
      </button>
    </span>
</template>
<script>
import CustomCheckbox from './CustomCheckbox'

export default {
  extends: CustomCheckbox,
}
</script>
